// `resume` returns false when the workflow considers the params incomplete, in
// which case nothing is cleared and the resume can fire again.

import {useEffect} from 'react';
import {useRoute, useNavigation} from '@react-navigation/native';

export function usePostScanResume(resume, clearKeys = []) {
  const route = useRoute();
  const navigation = useNavigation();

  useEffect(() => {
    const params = route?.params || {};
    if (!params.postScanningContinue) return;
    if (!Array.isArray(params.postScanningModulesRemaining)) return;
    if (!resume(params)) return;

    const cleared = {postScanningContinue: false};
    clearKeys.forEach(key => {
      cleared[key] = null;
    });
    navigation.setParams(cleared);
  }, [route?.params]);
}
